import template from 'lodash/template';

class Template {
  /**
   * テンプレートの用意.
   *
   * @param {string} templateID テンプレート要素のID
   */
  constructor(templateElement) {
    this.compiler = template(templateElement.innerHTML);
  }

  /**
   * データを流し込んだてプレートを表示.
   *
   * - target要素の中身を書き換える
   *
   * @param {HTMLElement} target
   * @param {object} data
   */
  insert(target, data) {
    target.innerHTML = this.compiler(data);
  }

  /**
   * データを流し込んだコンポーネントを表示.
   *
   * - target要素の最後の子要素として追加
   *
   * @param {HTMLElement} target
   * @param {object} data
   * @param {bool} isAppend 要素の先頭に追加するか最後に追加するか
   */
  add(target, data, isAppend=true) {
    const clone = target.cloneNode(false);
    clone.innerHTML = this.compiler(data);

    // 仮のHTML要素からテンプレートの取り出して、target要素の最後に追加する
    const compiler = clone.firstElementChild;
    if (isAppend) {
      target.appendChild(compiler);
    } else {
      target.prepend(compiler);
    }

  }
}

export default Template
